$(document).ready(function(){
  $("#customer_logout_link").click(function(){
     $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){
     
      },
      dataType: 'json'
    });
  });
  
 if($("#customer_login_link").length>0)
   {
     
     $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){
        
      },
      dataType: 'json'
    }
            );
   }
});
